/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'StartWeixin',
    // TODO 后续找时间改到 mpa/startWeixin/index.html 以提升加载
    path: '/startWeixin',
    component: () =>
      import(/* webpackChunkName: "StartWeixin" */ '@/views/start/weixin.vue'),
    meta: { title: '' },
  },
  {
    name: 'StartUP',
    path: '/startUp',
    component: () =>
      import(/* webpackChunkName: "StartUp" */ '@/views/start/startup.vue'),
    meta: { title: '' },
  },
  {
    name: 'StartApp',
    path: '/startApp',
    component: () =>
      import(/* webpackChunkName: "startApp" */ '@/views/start/startApp.vue'),
    meta: { title: '' },
  },
];
